import { Card, Flex } from 'antd'
import { createStyles } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { useCertificationsStore } from '../Store/hooks/useStore'

import { CertificationDescription } from './components/CertificationDescription'
import { CertificationImage } from './components/CertificationImage'
import { CertificationDeleteButton } from './components/DeleteButton'
import { CertificationShowModalButton } from './components/ShowModalButton'
import { CertificationValidDateRibbon } from './components/ValidDateRibbon'
import { CertificationsListProps } from './interface'

const useStyles = createStyles(({ token, prefixCls }) => ({
  content: {
    width: 400,
    background: token.colorBgLayout,
    [`& .${prefixCls}-card-actions>li`]: {
      margin: 0
    },
    [`& .${prefixCls}-card-body`]: {
      padding: 12
    }
  }
}))

export const CertificationsList = ({ disabled }: CertificationsListProps) => {
  const { styles } = useStyles()
  const { value: certifications } = useCertificationsStore(state =>
    pick(state, ['value'])
  )

  return (
    <Flex gap={12} wrap='wrap'>
      {certifications?.map(item => (
        <CertificationValidDateRibbon key={item.id} data={item}>
          <Card
            className={styles.content}
            actions={[
              <Flex key='actionBtnGroup' gap={0} justify='end'>
                <CertificationShowModalButton data={item} disabled={disabled} />
                {<CertificationDeleteButton data={item} disabled={disabled} />}
              </Flex>
            ]}
          >
            <Card.Meta
              avatar={<CertificationImage data={item} />}
              description={<CertificationDescription data={item} />}
            />
          </Card>
        </CertificationValidDateRibbon>
      ))}
    </Flex>
  )
}
